
/**
 * Cache to register leave categories for the current user
 * @kind cache
 * @class LeaveCategory
 * @description Custom lookup cache for LeaveCategories
 * @usage let lookup = await Grape.cache.get('LeaveCategory');
 */
export default {
	name: 'LeaveCategory',
	options: {
		table: 'leave_category',
		schema: 'public',
		limit: 1000000
	}
};
